import React from 'react';
import { Outlet } from 'react-router-dom';
import './BlankLayout.less';

const BlankLayout = () => {
  React.useEffect(() => {
    // H5 相关设置
    const setRem = () => {
      const htmlDom = document.getElementsByTagName('html')[0];
      const width = document.documentElement.clientWidth || document.body.clientWidth;
      const fontSize = (width / 375) * 16; // 基于375px的设计稿
      htmlDom.style.fontSize = fontSize <= 32 ? `${fontSize}px` : '32px';
    };

    setRem();
    window.addEventListener('resize', setRem);

    return () => window.removeEventListener('resize', setRem);
  }, []);

  return (
    <div className='blank-layout'>
      <Outlet />
    </div>
  );
};

export default BlankLayout;
